/*
 * <multitile-disclosure> — folds a Multi Content Tiles grid away behind its button.
 *
 * Progressive enhancement: the grid ships open and the CSS only collapses it once this
 * element is defined, so a blocked script leaves every tile readable. The button owns
 * `aria-expanded` and points at the grid with `aria-controls`; the grid itself is only
 * ever hidden with the `hidden` attribute, so nothing stays in the tab order when folded.
 */
class MultitileDisclosure extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    if (!this.button) return;
    this.grid = document.getElementById(this.button.getAttribute('aria-controls'));
    if (!this.grid) return;

    this.label = this.button.querySelector('.section-multitile__disclosure-text');
    this.setState(false);
    this.button.addEventListener('click', () => {
      this.setState(this.button.getAttribute('aria-expanded') !== 'true');
    });
  }

  setState(open) {
    this.button.setAttribute('aria-expanded', open ? 'true' : 'false');
    this.grid.hidden = !open;
    if (this.label) {
      this.label.textContent = open
        ? this.button.dataset.labelOpen || 'Hide'
        : this.button.dataset.labelClosed || 'View more';
    }
  }
}

if (!customElements.get('multitile-disclosure')) customElements.define('multitile-disclosure', MultitileDisclosure);
